export const COPY_ICON_NAME = 'clipboard-copy';
export const COPY_ICON_CLASS = '';
export const COPIED_ICON_NAME = 'clipboard-checked';
export const COPIED_ICON_CLASS = 'hds-foreground-action';
